import { render, staticRenderFns } from "./ConversationListItem.vue?vue&type=template&id=1bfe9099&class=chat-list&"
import script from "./ConversationListItem.vue?vue&type=script&lang=js&"
export * from "./ConversationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports